import React from "react";
import cs from "classnames";

import "./ui.scss";

export type NoticeTone = "success" | "danger" | "muted";

interface Props {
  tone: NoticeTone;
  children: React.ReactNode;
  className?: string;
}

export const Notice = ({ tone, children, className }: Props) => (
  <div className={cs("Notice", `Notice--${tone}`, className)}>
    <span className="Notice__dot" aria-hidden="true" />
    <span className="Notice__text">{children}</span>
  </div>
);
